"use strict";

// https://html.spec.whatwg.org/multipage/obsolete.html#dom-external
exports.implementation = class ExternalImpl {
  // The AddSearchProvider() and IsSearchProviderInstalled() methods must do nothing
  AddSearchProvider() {}

  IsSearchProviderInstalled() {}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/window/External-impl.js
// module id = TBkZ
// module chunks = 0